export const ALLOW = 'ALLOW'
export const DENY = 'DENY'

export const ALLOW_TOKEN = '43c0bdb2'
export const DENY_TOKEN = 'a4116de2'
export const INIT_VALUE = 'init'
export const PENDING_VALUE = 'pending'

export const HIDDEN_CUG_VALUES = new Set([DENY_TOKEN, INIT_VALUE])

const ONE_DAY = 1

export const TOKEN_EXPIRE_MAPPER = {
  [ALLOW_TOKEN]: ONE_DAY,
  [DENY_TOKEN]: ONE_DAY
}

export const SCREENSHOT_VIEW_RULE_ID = 'screenshots_session'

export const CHAIN_HOTEL_VIEW_RULE_ID = 'chain_checker_session'
export const CHAIN_HOTEL_VIEW_LIMIT = 3

export const accessControlActionCookieName = 'actcn'

export const accessControlRules = [
  {
    criteria: 'user.id != undefined',
    value: ["'user.id:'+user.id+'<score=1>'"]
  },
  {
    criteria: 'user.emailDomain != undefined',
    value: ["'user.emailDomain:'+user.emailDomain+'<score=1>'"]
  },
  {
    criteria: 'user.anonymousId != undefined',
    value: ["'user.anonymousId:'+user.anonymousId+'<score=1>'"]
  },
  {
    criteria: 'device.id != undefined',
    value: ["'device.id:'+device.id+'<score=1>'"]
  },
  {
    criteria: 'device.type != undefined',
    value: ["'device.type:'+device.type+'<score=1>'"]
  },
  {
    criteria: 'ip.address != undefined',
    value: ["'ip.address:'+ip.address+'<score=1>'"]
  },
  {
    criteria: 'ip.country != undefined',
    value: ["'ip.country:'+ip.country+'<score=1>'"]
  },
  {
    criteria: 'ip.isAnonymous != undefined',
    value: ["'ip.isAnonymous:'+ip.isAnonymous+'<score=1>'"]
  },
  {
    criteria: 'urlParameters.utm_source != undefined',
    value: ["'urlParameters.utm_source:'+urlParameters.utm_source+'<score=1>'"]
  },
  {
    criteria: 'urlParameters.gsite != undefined',
    value: ["'urlParameters.gsite:'+urlParameters.gsite+'<score=1>'"]
  },
  {
    criteria: 'search.dayDistance != undefined',
    value: ["'search.dayDistance:'+search.dayDistance+'<score=1>'"]
  },
  {
    criteria: 'search.currency != undefined',
    value: ["'search.currency:'+search.currency+'<score=1>'"]
  },
  {
    criteria: 'search.language != undefined',
    value: ["'search.language:'+search.language+'<score=1>'"]
  },
  {
    criteria: 'search.dayHour != undefined',
    value: ["'search.dayHour:'+search.dayHour+'<score=1>'"]
  },
  {
    criteria: 'search.weekDay != undefined',
    value: ["'search.weekDay:'+search.weekDay+'<score=1>'"]
  },
  {
    criteria: 'rate.hotelId != undefined',
    value: ["'rate.hotelId:'+rate.hotelId+'<score=1>'"]
  },
  {
    criteria: 'rate.hotelCountry != undefined',
    value: ["'rate.hotelCountry:'+rate.hotelCountry+'<score=1>'"]
  },
  {
    criteria: 'rate.tier != undefined',
    value: ["'rate.tier:'+rate.tier+'<score=1>'"]
  },
  {
    criteria: 'true',
    value: [
      "optionalFiltersScoreOffset|map('optionalFiltersScoreOffset:%s<score=%s>')"
    ]
  }
]
